export const USER_IS_ROOT = 1;
export const USER_IS_CLIENT = 2;
